// Copyright (c) StrangeBee 2024

import React, { ReactElement } from 'react';
import { Link } from 'react-router-dom';
import { HeaderActionType } from '@Types';
import THEntityLayout from '@Organisms/THEntityLayout/THEntityLayout';
import { useLocalMessage } from '@Helpers/';
import RouteBuilder from '@Services/RouteBuilder';
import { RouteType } from '@Types';
import ChildRoutes from './routes';
import { ICONS } from '@Constants/iconsApp';
import { AdminPermissionsEnum, PermissionsEnum } from 'thehive-sdk';
import { findDefaultPath } from '@Helpers/RedirectPath';
import { useCurrentUser } from '@Queries/userQueries';
import { useGetAccessibleRoutes } from '@Helpers/getAccessibleRoutes';

const PlatformManagementDetails = (): ReactElement | null => {
    const i = useLocalMessage();
    const accessibleRoutes = useGetAccessibleRoutes(ChildRoutes);

    const HeaderActions: HeaderActionType[] = [];

    return (
        <THEntityLayout
            className="layout-org"
            routes={accessibleRoutes}
            title={i('breadcrumb.global.platform-management')}
            actions={HeaderActions}
        />
    );
};

const path = RouteBuilder.compute('administration.platform');

const MenuLink = (): ReactElement => {
    const i = useLocalMessage();

    const { data: currentUser } = useCurrentUser();
    const { permissions = [] } = currentUser || {};
    const defaultPath = findDefaultPath(permissions, {
        [PermissionsEnum.MANAGE_PLATFORM]: 'administration.license',
        //     []: 'administration.status',
        //     []: 'administration.branding',
        [PermissionsEnum.MANAGE_CONFIG]: 'administration.cortex',
        //     [PermissionsEnum.MANAGE_CONFIG]: 'administration.misp',
        //     [PermissionsEnum.MANAGE_CONFIG]: 'administration.authentication',
        //     [PermissionsEnum.MANAGE_CONFIG]: 'administration.mailer',
        //     [PermissionsEnum.MANAGE_CONFIG]: 'administration.webhook',
    });

    return <Link to={RouteBuilder.compute(defaultPath)}>{i('breadcrumb.global.platform-management')}</Link>;
};

export const Route: RouteType = {
    path,
    menu: {
        label: 'organisation.layout.nav-bar.users',
        key: 'platform',
        icon: <ICONS.PlatformIcon />,
        render: <MenuLink />,
        selectTab: path,
        group: 'platform-management',
        space: ['admin'],
    },
    content: <PlatformManagementDetails />,
    space: ['admin'],
    permissionNeeded: [AdminPermissionsEnum.MANAGE_PLATFORM, PermissionsEnum.MANAGE_CONFIG],
    breadcrumb: {
        label: 'breadcrumb.global.platform-management',
        isLink: false,
    },
};
